import React from 'react';
import { ImageTitleContent } from '@axa-asia/emma-stylesheet';
import { useSelector } from 'react-redux';
import { getMyWellnessRulesInfo } from '../../selectors/aktivoOnboardingSelectors';
import { getLanguage } from '../../../healthkeeper/selectors/configSelectors';
import { isApp, resolveLargeImage } from '../../../../utils';
import './style.scss';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { goto } from '../../../../actions/historyActions';
import { getAktivoAgreedTnc } from '../../../../selectors/authSelectors';

const MyWellnessRules = () => {
  const rulesConfig = useSelector(getMyWellnessRulesInfo);
  const isAgreedTnc = useSelector(getAktivoAgreedTnc);
  const language = useSelector(getLanguage);
  const openDeeplink = (deeplink: string) => {
    if (isApp()) {
      EmmaFactory.createInstance().then((e) => {
        e.instance.goTo(deeplink);
      });
    } else {
      goto(deeplink);
    }
  };
  return (
    <div className="my-wellness-rules__container">
      {!!rulesConfig.cards &&
        rulesConfig.cards.map((card: any, index: number) => {
          return (
            <div
              className="my-wellness-rules__card-container"
              style={
                !index
                  ? { boxShadow: '0 15px 10px -15px rgb(0 0 0 / 15%)' }
                  : {}
              }
              key={index.toString()}
            >
              {card.image && card.title && card.description && (
                <ImageTitleContent
                  image={resolveLargeImage(card.image)}
                  title={card.title[language]}
                  content={card.description[language]}
                />
              )}
              {card.topicCard && (
                <div className="my-wellness-rules__topic-card__container">
                  <div className="my-wellness-rules__topic-card__title">
                    {card.topicCard.title[language]}
                  </div>
                  <div className="my-wellness-rules__topic-card__item">
                    {card.topicCard.items.map(
                      (topicCard: any, topicCardIndex: number) => (
                        <div
                          key={topicCardIndex.toString()}
                          className="my-wellness-rules__topic-card__item__container"
                        >
                          <div
                            className="my-wellness-rules__topic-card__item__image"
                            style={{
                              backgroundImage: `url(${
                                !!topicCard &&
                                !!topicCard.image &&
                                resolveLargeImage(topicCard.image)
                              })`,
                            }}
                          />
                          <div className="my-wellness-rules__topic-card__item__title">
                            {topicCard && topicCard.title[language]}
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              )}
              {isApp() && (card.buttonOneText || card.buttonTwoText) && (
                <div className="my-wellness-rules__buttons__container">
                  {card.buttonOneText && !isAgreedTnc && (
                    <button
                      className="emma-stylesheet-primary-default-button"
                      onClick={() => openDeeplink(card.buttonOneDeeplink)}
                      data-enable-ga
                      data-ga-type="button"
                    >
                      {card.buttonOneText[language]}
                    </button>
                  )}
                  {card.buttonOneText && card.buttonTwoText && (
                    <div style={{ marginTop: 8 }} />
                  )}
                  {card.buttonTwoText && (
                    <button
                      className="emma-stylesheet-primary-ghost-button"
                      onClick={() => openDeeplink(card.buttonTwoDeeplink)}
                      data-enable-ga
                      data-ga-type="button"
                    >
                      {card.buttonTwoText[language]}
                    </button>
                  )}
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default MyWellnessRules;
